import { baseApi } from ".";

export interface FieldAvailabilityParams {
  resource: string;
  field: string;
  value: string;
  exclude_id?: number;
  exclude_token?: string;
}

export interface FieldAvailabilityResponse {
  resource: string;
  field: string;
  value: string;
  available: boolean;
  code?: string;
  context?: Record<string, unknown>;
}

export const fieldValidationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    checkFieldAvailability: builder.query<FieldAvailabilityResponse, FieldAvailabilityParams>({
      query: ({ resource, field, value, exclude_id, exclude_token }) => ({
        url: "/api/validation/field-availability/",
        method: "POST",
        body: { resource, field, value, exclude_id, exclude_token },
        credentials: "include" as const,
      }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useCheckFieldAvailabilityQuery } = fieldValidationApi;
